function appendArrowToButtons() {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M89.49,0H7.51C3.36,0,0,3.36,0,7.51s3.36,7.51,7.51,7.51h66.84L6.25,83.12c-2.93,2.93-2.93,7.69,0,10.62,1.47,1.47,3.39,2.2,5.31,2.2s3.85-.73,5.31-2.2L84.98,25.65v66.84c0,4.15,3.36,7.51,7.51,7.51s7.51-3.36,7.51-7.51V10.51c0-5.8-4.72-10.51-10.51-10.51Z"/></svg>`;

  document.querySelectorAll('a.custom-btn.has-arrow, .buttonContactCustom').forEach((btn) => {
    btn.insertAdjacentHTML('beforeend', svg);
  });
}

appendArrowToButtons();


function initFeatureSwiper() {
  const section = document.querySelector('.custom-features');
  if (!section) return;

  const wrapper = section.querySelector('[class*="features-items-template"]');
  const items = section.querySelectorAll('[class*="features-item-template"]');

  if (!wrapper || !items.length) return;

  let swiperInstance = null;
  let isWrapped = false;

  function setupDOM() {
    if (isWrapped) return;

    wrapper.classList.add('swiper-wrapper');
    items.forEach(item => item.classList.add('swiper-slide'));

    const swiperDiv = document.createElement('div');
    swiperDiv.classList.add('swiper', 'featureSwiper');
    wrapper.parentNode.insertBefore(swiperDiv, wrapper);
    swiperDiv.appendChild(wrapper);

    const pagination = document.createElement('div');
    pagination.classList.add('swiper-pagination');
    swiperDiv.appendChild(pagination);

    isWrapped = true;
  }

  function initSwiper() {
    setupDOM();
    if (swiperInstance) return;

    // Override the grid layout so Swiper can take over
    wrapper.style.display = 'flex';
    wrapper.style.gap = '0';
    wrapper.style.marginTop = '0';

    swiperInstance = new Swiper('.featureSwiper', {
      loop: true,
      slidesPerView: 1,
      
      pagination: {
        el: '.featureSwiper .swiper-pagination',
        clickable: true,
      },
    });
  }

  function destroySwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;

      // Restore grid layout
      wrapper.style.display = '';
      wrapper.style.gap = '';
      wrapper.style.marginTop = '';
    }
  }

  function handleResize() {
    if (window.innerWidth <= 600) {
      initSwiper();
    } else {
      destroySwiper();
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);
}

// Wait for Swiper to be available
function waitForSwiper(cb, retries = 20) {
  if (typeof Swiper !== 'undefined') {
    cb();
  } else if (retries > 0) {
    setTimeout(() => waitForSwiper(cb, retries - 1), 100);
  }
}

document.addEventListener('DOMContentLoaded', () => waitForSwiper(initFeatureSwiper));

// Smooth scrolling
document.addEventListener('click', function (e) {
  const link = e.target.closest('a.sticks-btn[href^="#"]');
  if (!link) return;

  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;

  e.preventDefault();
  window.scrollTo({
    top: target.offsetTop - 80,
    behavior: 'smooth'
  });
});

(function () {
  const section = document.querySelector('.custom-form');
  if (!section) return;

  if (document.getElementById('projektanfragen')) return;

  const anchor = document.createElement('div');
  anchor.id = 'projektanfragen';

  section.prepend(anchor);
})();


// Google Tag Manager = Track Chat-Click
(function () {
  var eventName = 'shopify_agent_open';
  function observeAgent(agent) {
    if (!agent || agent.dataset.gtmOpenObserver === 'true') {
      return;
    }
    agent.dataset.gtmOpenObserver = 'true';
    var wasOpen = agent.hasAttribute('open');
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'open') {
          return;
        }
        var isOpen = agent.hasAttribute('open');
        if (isOpen && !wasOpen) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: eventName,
            shopify_agent_view: agent.getAttribute('view') || ''
          });
        }
        wasOpen = isOpen;
      });
    });
    observer.observe(agent, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  function findAgents() {
    document.querySelectorAll('shopify-agent').forEach(observeAgent);
  }

  findAgents();
  var documentObserver = new MutationObserver(findAgents);
  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();
